'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
}; // Libs
// Other objects


var _dateFns = require('date-fns');

var _dualDateDigit = require('./dualDateDigit.date');

var _dualDateDigit2 = _interopRequireDefault(_dualDateDigit);

var _time = require('./time.date');

var _time2 = _interopRequireDefault(_time);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var empty = {
  day: null,
  month: null,
  year: null,
  hour: null,
  minutes: null,
  dayPart: null
};

var create = function create() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  if (!str) return empty;
  var parsed = (0, _dateFns.parse)(str);
  if (!(0, _dateFns.isDate)(parsed)) return empty;
  var year = '' + (0, _dateFns.getYear)(parsed);
  var month = (0, _dualDateDigit2.default)((0, _dateFns.getMonth)(parsed) + 1);
  var day = (0, _dualDateDigit2.default)((0, _dateFns.getDate)(parsed));
  var hour = (0, _dualDateDigit2.default)((0, _dateFns.getHours)(parsed));
  var minutes = (0, _dualDateDigit2.default)((0, _dateFns.getMinutes)(parsed));
  return _extends({
    day: day,
    month: month,
    year: year
  }, _time2.default.create(hour + ':' + minutes + ':00'));
};

var revert = function revert(_ref) {
  var day = _ref.day,
      month = _ref.month,
      year = _ref.year,
      hour = _ref.hour,
      minutes = _ref.minutes,
      dayPart = _ref.dayPart;
  return (0, _dateFns.format)(new Date(year, Number(month) - 1, day, Number(hour) + (dayPart === 'pm' ? 12 : 0), minutes), 'YYYY-MM-DDTHH:mm:ssZ');
};

var toDate = function toDate() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$day = _ref2.day,
      day = _ref2$day === undefined ? null : _ref2$day,
      _ref2$month = _ref2.month,
      month = _ref2$month === undefined ? null : _ref2$month,
      _ref2$year = _ref2.year,
      year = _ref2$year === undefined ? null : _ref2$year,
      _ref2$hour = _ref2.hour,
      hour = _ref2$hour === undefined ? null : _ref2$hour,
      _ref2$minutes = _ref2.minutes,
      minutes = _ref2$minutes === undefined ? null : _ref2$minutes,
      _ref2$dayPart = _ref2.dayPart,
      dayPart = _ref2$dayPart === undefined ? null : _ref2$dayPart;

  return !day || !month || !year || !hour || !minutes || !dayPart ? null : new Date(year, Number(month) - 1, day, Number(hour) + (dayPart === 'pm' ? 12 : 0), minutes);
};

exports.default = {
  type: 'datetime',
  create: create,
  revert: revert,
  toDate: toDate
};